import * as React from "react";
import { cn } from "../lib/cn";

export function Input({
  className,
  type,
  ...props
}: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-8.5 w-full min-w-0 rounded-md border border-border-strong bg-bg-raised px-3 text-sm text-fg transition-colors",
        "placeholder:text-fg-faint",
        "focus-visible:border-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft",
        "disabled:pointer-events-none disabled:opacity-50",
        "aria-invalid:border-danger",
        className,
      )}
      {...props}
    />
  );
}
